<ng-container>
  <li class="nav-item content-buttons-container mr-3">
    @for (option of options; track option) {
      <button type="button"
        class="btn button-item-border my-1"
            [ngClass]="{
              'active': selectedMeteos.includes(option),
              'disabled': optionsInactive.includes(option)
            }"
        (click)="optionSelectedMulti(option)">
        {{ meteoServicesLabels[option].label === 'Wind-Log' ? 'GPM Horizon' : (meteoServicesLabels[option].label |translate) }}
      </button>
    }
    @if (allowsMultiSelection) {
      <button type="button" class="btn {{ isAllSelected ? 'active' : 'button-item-border mr-0' }}"
        (click)="optionSelectedMulti('all')">
        {{'FORECAST.METEOSERVICE.ALL' | translate}}
      </button>
    }
  </li>
</ng-container>
